import { render, staticRenderFns } from "./inspectionItemManageList.vue?vue&type=template&id=72a0ed97&scoped=true"
import script from "./inspectionItemManageList.vue?vue&type=script&lang=js"
export * from "./inspectionItemManageList.vue?vue&type=script&lang=js"
import style0 from "./inspectionItemManageList.vue?vue&type=style&index=0&id=72a0ed97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0ed97",
  null
  
)

export default component.exports